//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class SchoolMakeUpCreditLimitSettingsUpdateItem extends ItemBase {
    Limit?: number;
    Date?: string;

    constructor(initializer?: Partial<SchoolMakeUpCreditLimitSettingsUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SchoolMakeUpCreditLimitSettingsUpdateItem";
}
